import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TabPanel, TabView } from 'primereact/tabview';

// Data table
import { Skeletonitems, SkeletonbodyTemplate } from '../../../appconfig/Settings';

import { MasterTab } from '../MasterTab';
import { getAllDetailsDirect, postAllData } from '../../../service/ProductService';
import { APPLICATIONS, BILL_MASTER, GNOUSERDETAILS, LINKWITHGNO, MASTERUSERLIST, REGENERATE_SMART_CARD, UPDATE_PROFILE_PIC, USERCHANGEEMAIL, USERCHANGEPASSWORD } from '../../../config/ApiConstant';
import { UserUpdateEmailPassValidate, UserUpdatePhotoValidate, UserUpdateValidate, UserUploadPhotoValidate } from '../../../config/Validate';
import { ChangePhotoListColumns, ReGenerateListColumns, UserLinkGnoListColumns } from '../../../appconfig/DatatableSetting';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { dateFormatTemplate, formatYearMonthDate } from '../../../appconfig/AppHelper';
import { Password } from 'primereact/password';
import { Buffer } from 'buffer';
import { combinedFullNameTemplate, commonImageTemplate, dateTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { Badge } from 'primereact/badge';

export const UserUpdate = () => {
    document.title = 'User Link With GNo. | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [applications, setApplications] = useState<any>([]);
    const [userUpdateData, setUserUpdateData] = useState<any>({});
    const [totalAmount, setTotalAmount] = useState<any>('');
    const [submitLoading, setSubmitLoading] = useState<boolean>(false);
    const [showLoading, setShowLoading] = useState<boolean>(false);

    const [tableItems, setTableItems] = useState<any>([]);
    const [updatePhototableItems, setUpdatePhotoTableItems] = useState<any>([]);
    const [errors, setErrors] = useState<any>({});

    const [activeIndex, setActiveIndex] = useState<any>(0);

    // re-generate modal
    const [confirmModal, setConfirmModal] = useState<boolean>(false);
    const [selectedSrNo, setSelectedSrNo] = useState<any>(null);
    const [regenerateLoader, setRegenerateLoader] = useState<boolean>(false);

    //gnoModel
    const [linkGnoModal, setLinkGnoModal] = useState<boolean>(false);
    const [userId, setUserId] = useState<any>(null);
    const [addUpdateLoader, setAddUpdateLoader] = useState<boolean>(false);
    const [date, setDate] = useState<any>();

    const [password, setPassword] = useState<any>('12345678');

    //photoUpdateModal
    const [photoModal, setPhotoModal] = useState<boolean>(false);
    const [userSrNo, setUserSrNo] = useState<any>(null);
    const [userImage, setUserImage] = useState<any>(null);

    const [addUpdatePhotoLoader, setAddUpdatePhotoLoader] = useState<boolean>(false);

    // useEffect
    useEffect(() => {
        getAllApplications();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // useEffect(() => {
    //     getuserUpdateData();
    // }, [userUpdateData?.applicationName?.code]);

    // Get all applications
    const getAllApplications = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetailsDirect(APPLICATIONS);
            if (response) {
                let appOption: any = [];
                response.map((option: any) => {
                    const row = {
                        name: option.AppName,
                        code: option.SrNo
                    };
                    appOption.push(row);
                });
                setApplications(appOption);
                setPageLoad(true);
            }
        } catch (error: any) {
            setPageLoad(true);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
        setUserUpdateData({});
    };

    //onchange event
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name === 'photo') {
            val = e.target.files[0] || '';
        } else {
            val = (e.target && e.target.value) || e.value || '';
        }
        setUserUpdateData({ ...userUpdateData, [name]: val });
    };

    // handle change date
    const handleChangeDate = (val: any) => {
        setDate(val);
    };

    //sattusTemplate
    const statusTemplate = (rowData: any) => {
        return <div>{!window.cn(rowData?.user_application) ? (!window.cn(rowData?.user_application.RegNo) ? 'Already Linked' : 'Already Application Exist') : 'Not Linked'}</div>;
    };

    //linkGnoTemplate
    const linkGnoTemplate = (rowData: any) => {
        let status = !window.cn(rowData?.user_application) && !window.cn(rowData?.user_application?.RegNo) ? rowData?.user_application?.RegNo : '-';
        return <div>{status}</div>;
    };

    //actionTenplate
    const actionTemplate = (rowData: any) => {
        return <Button label="Link With GNo." loading={submitLoading} disabled={!window.cn(rowData?.user_application) ? true : false} onClick={() => openLinkGNoModal(rowData?.id)}></Button>;
    };

    //open LinjGnoModel
    const openLinkGNoModal = (userId: any) => {
        setLinkGnoModal(true);
        setUserId(userId);
    };

    //close model
    const closeLinkGnoModal = () => {
        setLinkGnoModal(false);
        setUserId(null);
        setUserUpdateData({
            ...userUpdateData,
            reg_no: ''
        });
        setDate(null);
    };

    // Get all Data
    const getuserUpdateData = async () => {
        try {
            setPageLoad(false);
            setShowLoading(true);
            const response = await getAllDetailsDirect(MASTERUSERLIST + '?email=' + userUpdateData?.email + '&mobile=' + userUpdateData?.mobile);

            //Check response
            if (response) {
                setTableItems(response);
                setPageLoad(true);
                setShowLoading(false);
            }
        } catch (error: any) {
            setPageLoad(true);
            setShowLoading(false);

            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get User Data
    const getuserData = async () => {
        try {
            const { errors, isError } = UserUpdatePhotoValidate(userUpdateData);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setPageLoad(false);
                setShowLoading(true);
                const requestData = {
                    reg_no: userUpdateData?.update_photo_reg_no
                };

                const response = await postAllData(GNOUSERDETAILS, requestData);

                //Check response
                if (response) {
                    let photoData = [];
                    photoData.push(response?.data);
                    setUpdatePhotoTableItems(photoData);
                    setPageLoad(true);
                    setShowLoading(false);
                }
            }
        } catch (error: any) {
            setPageLoad(true);
            setShowLoading(false);

            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Add application bill master
    const saveUserDetails = async () => {
        try {
            const { errors, isError } = UserUpdateValidate(userUpdateData, date);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setAddUpdateLoader(true);

                //Request Data
                const requestData = {
                    user_id: userId,
                    regno: userUpdateData?.reg_no,
                    bod: formatYearMonthDate(date)
                };

                const response = await postAllData(LINKWITHGNO, requestData);
                if (response) {
                    setLinkGnoModal(false);
                    getuserUpdateData();
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.data });

                    setAddUpdateLoader(false);
                }
            }
        } catch (error: any) {
            if (error.response) {
                setAddUpdateLoader(false);
                setPageLoad(true);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.response.data.error
                });
            }
        }
    };

    //updateUserDeatils
    const userUpdateDetails = async () => {
        try {
            const { errors, isError } = UserUpdateEmailPassValidate(userUpdateData, activeIndex);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setSubmitLoading(true);

                let requestData = {};

                let Bufpassword = '';

                if (activeIndex == 2) {
                    Bufpassword = Buffer.from(password).toString('base64');
                }

                activeIndex === 1
                    ? (requestData = {
                        exist_email: userUpdateData.old_email,
                        new_email: userUpdateData.new_email
                    })
                    : (requestData = {
                        exist_user_email: userUpdateData.exist_email,
                        password: Bufpassword
                    });

                let URL = '';
                activeIndex === 1 ? (URL = USERCHANGEEMAIL) : (URL = USERCHANGEPASSWORD);

                const response = await postAllData(URL, requestData);
                if (response) {
                    setSubmitLoading(false);
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.data });

                    userUpdateData({});
                }
            }
        } catch (error: any) {
            if (error.response) {
                setSubmitLoading(false);
                setPageLoad(true);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: error.response.data.error
                });
            }
        }
    };

    //photoaction Template
    const photoActionTemplate = (rowData: any) => {
        return (
            <>
                <Button label="Update Photo" loading={submitLoading} onClick={() => openUpdatePhotoModal(rowData?.Image, rowData?.SrNo)}></Button>
            </>
        );
    };

    //regenerate Template
    const regenerateActionTemplate = (rowData: any) => {
        return (
            <Button label="Re-Generate Smart Card" onClick={() => openRegenerateConfirm(rowData?.SrNo)} />
        );
    };

    //download regenerate Template
    const downloadRegenerateTemplate = (rowData: any) => {
        if (!window.cn(rowData?.smart_card_url)) {
            return (
                <a
                    href={rowData.smart_card_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Download Smart Card"
                >
                    <Button
                        icon="pi pi-file-pdf"
                        className="p-button-rounded p-button-text p-button-danger"
                        tooltip="Download PDF"
                        tooltipOptions={{ position: 'top' }}
                    />
                </a>
            );
        }

        return <Badge value="Not Downloaded" severity="warning" />;
    };

    // open regenerate modal
    const openRegenerateConfirm = (srNo: any) => {
        setSelectedSrNo(srNo);
        setConfirmModal(true);
    };

    // close regenerate modal
    const closeRegenerateConfirm = () => {
        setConfirmModal(false);
        setSelectedSrNo(null);
    };

    // handle regenerate submit
    const regenerateSmartCard = async () => {
        try {
            setRegenerateLoader(true);

            // regenerate API
            const response = await postAllData(REGENERATE_SMART_CARD, { sr_no: selectedSrNo });

            if (response) {

                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Smart Card regenerated successfully'
                });
                setConfirmModal(false);
                setRegenerateLoader(false);
                getuserData();
            }

        } catch (error) {
            setRegenerateLoader(false);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to regenerate smart card'
            });
        }
    };



    //open Update Photo Modal
    const openUpdatePhotoModal = (Image: any, SrNo: any) => {
        setPhotoModal(true);
        setUserSrNo(SrNo);
        let profilePictureTypeObject: any;
        if (Image && !window.cn(Image)) {
            const profilePictureName = !window.cn(Image) && Image.split('/').pop();

            const extractedprofilePictureName = !window.cn(profilePictureName) && profilePictureName.split('-').slice(1).join('-');

            // Extract the file name from the URL

            // Extract the file type from the file name
            const profilePictureType = `image/${profilePictureName.split('.').pop()}`;
            // Create the desired object
            profilePictureTypeObject = {
                url: Image,
                name: extractedprofilePictureName,
                type: profilePictureType
            };
            setUserImage(profilePictureTypeObject);
        }
    };

    //close Update Photo Modal
    const closeUpdatePhotoModal = () => {
        setPhotoModal(false);
        setUserSrNo(null);
        setUserImage(null);
    };

    //update Profile picture
    const updateProfilePhoto = async () => {
        try {
            const { errors, isError } = UserUploadPhotoValidate(userUpdateData);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setAddUpdatePhotoLoader(true);

                // Request object
                let formRequestData = new FormData();

                formRequestData.append('profile_pic', userUpdateData?.photo);
                formRequestData.append('SrNo', userSrNo);

                const response = await postAllData(UPDATE_PROFILE_PIC, formRequestData);
                if (response) {
                    setAddUpdatePhotoLoader(false);
                    closeUpdatePhotoModal();
                    // getuserData();

                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.data });
                }
            }
        } catch (error: any) {
            if (error.response) {
                setAddUpdatePhotoLoader(false);
                setPageLoad(true);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Sorry Could Not Load Data'
                });
            }
        }
    };

    return (
        <>
            <MasterTab mainTabLabel="User Bind / Email Update / Password Update" />
            <Toast ref={toast} />
            <div className="card mt-4">
                <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                    <TabPanel header="User Link">
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-6">
                                <label htmlFor="email">Email</label>
                                <div className="input-effect-div">
                                    <InputText value={userUpdateData?.email} name="email" onChange={(e) => onInputChange(e, 'email')} />
                                </div>
                                <small className="p-invalid-txt">{errors['email']}</small>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label htmlFor="mobile">Mobile</label>
                                <div className="input-effect-div">
                                    <InputText value={userUpdateData?.mobile} keyfilter={'num'} name="mobile" onChange={(e) => onInputChange(e, 'mobile')} />
                                </div>
                                <small className="p-invalid-txt">{errors['mobile']}</small>
                            </div>
                        </div>

                        <div className="formgrid grid">
                            <div className="field col-12 md:col-12">
                                <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                                    <Button label="SHOW" onClick={() => getuserUpdateData()} loading={showLoading} />
                                </div>
                            </div>
                        </div>

                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={tableItems}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive "
                                    emptyMessage="No Data Found"
                                >
                                    {UserLinkGnoListColumns.map((col, i) => {
                                        if (col.field === 'status') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={statusTemplate} />;
                                        } else if (col.field === 'linkedgno') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={linkGnoTemplate} />;
                                        } else if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {UserLinkGnoListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </TabPanel>
                    <TabPanel header="User Change Email">
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-6">
                                <label htmlFor="old_email">Email</label>
                                <div className="input-effect-div">
                                    <InputText value={userUpdateData?.old_email} name="old_email" onChange={(e) => onInputChange(e, 'old_email')} />
                                </div>
                                <small className="p-invalid-txt">{errors['old_email']}</small>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label htmlFor="new_email">New Email</label>
                                <div className="input-effect-div">
                                    <InputText value={userUpdateData?.new_email} name="new_email" onChange={(e) => onInputChange(e, 'new_email')} />
                                </div>
                                <small className="p-invalid-txt">{errors['new_email']}</small>
                            </div>
                        </div>

                        <div className="formgrid grid">
                            <div className="field col-12 md:col-12">
                                <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                                    <Button label="UPDATE" onClick={() => userUpdateDetails()} loading={submitLoading} />
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="User Change Password">
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-6">
                                <label htmlFor="exist_email">Email</label>
                                <div className="input-effect-div">
                                    <InputText value={userUpdateData?.exist_email} name="exist_email" onChange={(e) => onInputChange(e, 'exist_email')} />
                                </div>
                                <small className="p-invalid-txt">{errors['exist_email']}</small>
                            </div>
                            <div className="field col-12 md:col-6">
                                <label htmlFor="pass">Password</label>
                                <div className="input-effect-div">
                                    <Password value={password} name="password" feedback={false} toggleMask disabled />
                                </div>
                                <small className="p-invalid-txt">Default Password Set(12345678)</small>
                            </div>
                        </div>

                        <div className="formgrid grid">
                            <div className="field col-12 md:col-12">
                                <div style={{ display: 'flex', float: 'right', gap: 4 }}>
                                    <Button label="UPDATE" onClick={() => userUpdateDetails()} loading={submitLoading} />
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="Change Passport Size Photo">
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-6">
                                <label htmlFor="update_photo_reg_no">Reg No</label>
                                <div className="input-effect-div">
                                    <InputText value={userUpdateData?.update_photo_reg_no} name="update_photo_reg_no" onChange={(e) => onInputChange(e, 'update_photo_reg_no')} />
                                </div>
                                <small className="p-invalid-txt">{errors['update_photo_reg_no']}</small>
                            </div>

                            <div className="field col-12 md:col-6 ">
                                <Button label="SHOW" onClick={() => getuserData()} loading={showLoading} style={{ width: 'fit-content', marginTop: '25px' }} />
                            </div>
                        </div>

                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={updatePhototableItems}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive "
                                    emptyMessage="No Data Found"
                                >
                                    {ChangePhotoListColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={photoActionTemplate} />;
                                        } else if (col.field === 'RegDt') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} />;
                                        } else if (col.field === 'LastVDate') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} />;
                                        } else if (col.field === 'StudF') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={combinedFullNameTemplate} />;
                                        } else if (col.field === 'Image') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={commonImageTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {ChangePhotoListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </TabPanel>
                    <TabPanel header="Re-Generate Smart Card">
                        <div className="p-fluid formgrid grid">
                            <div className="field col-12 md:col-6">
                                <label htmlFor="update_photo_reg_no">Reg No</label>
                                <div className="input-effect-div">
                                    <InputText value={userUpdateData?.update_photo_reg_no} name="update_photo_reg_no" onChange={(e) => onInputChange(e, 'update_photo_reg_no')} />
                                </div>
                                <small className="p-invalid-txt">{errors['update_photo_reg_no']}</small>
                            </div>

                            <div className="field col-12 md:col-6 ">
                                <Button label="SHOW" onClick={() => getuserData()} loading={showLoading} style={{ width: 'fit-content', marginTop: '25px' }} />
                            </div>
                        </div>

                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={updatePhototableItems}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive "
                                    emptyMessage="No Data Found"
                                >
                                    {ReGenerateListColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={regenerateActionTemplate} />;
                                        } else if (col.field === 'RegDt') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} />;
                                        } else if (col.field === 'LastVDate') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} />;
                                        } else if (col.field === 'StudF') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={combinedFullNameTemplate} />;
                                        } else if (col.field === 'Image') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={commonImageTemplate} />;
                                        } else if (col.field === 'certificate') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={downloadRegenerateTemplate} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {ReGenerateListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </TabPanel>
                </TabView>
            </div>

            {/* Add Update GNo Dialog */}
            <Dialog
                visible={linkGnoModal}
                className="p-fluid"
                style={{ width: '500px' }}
                header={'User Link With GNo.'}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeLinkGnoModal} />
                        <Button label="Submit" icon="pi pi-check" className="p-button-primary" onClick={() => saveUserDetails()} loading={addUpdateLoader} />
                    </>
                }
                onHide={closeLinkGnoModal}
            >
                <div className="formgrid grid">
                    <div className="field col-12 md:col-12">
                        <label htmlFor="reg_no">
                            G No. <span style={{ color: 'red' }}>*</span>
                        </label>
                        <div className="input-effect-div">
                            <InputText value={userUpdateData?.reg_no} name="reg_no" autoComplete="off" placeholder="Enter G No" onChange={(e) => onInputChange(e, 'reg_no')} className={errors['reg_no'] && 'p-invalid'} />
                            <span className="focus-bg"></span>
                        </div>

                        <small className="p-invalid-txt">{errors['reg_no']}</small>
                    </div>
                    <div className="field col-12 md:col-12">
                        <label htmlFor="date">Date</label>
                        <div className="input-effect-div">
                            <Calendar
                                value={date}
                                dateFormat="dd-M-yy"
                                onChange={(e: any) => {
                                    handleChangeDate(e.value);
                                }}
                                showIcon
                                className={errors['date'] && 'p-invalid'}
                            />
                            <small className="p-invalid-txt">{errors['date']}</small>
                        </div>
                    </div>
                </div>
            </Dialog>

            {/* Close Add Update GNo Dialog */}

            {/* Add Update Photo Dialog */}
            <Dialog
                visible={photoModal}
                className="p-fluid"
                style={{ width: '500px' }}
                header={'Upadte Profile Picture'}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeUpdatePhotoModal} />
                        <Button label="Submit" icon="pi pi-check" className="p-button-primary" onClick={() => updateProfilePhoto()} loading={addUpdatePhotoLoader} />
                    </>
                }
                onHide={closeUpdatePhotoModal}
            >
                <div className="formgrid grid">
                    <div className="field col-12 md:col-12">
                        <label htmlFor="photo">Upload Photo *</label>
                        <div className="upload-box">
                            <i className="pi pi-upload" style={{ fontSize: '1.2rem', marginRight: '0.5rem' }}></i>
                            <span>Upload Photo</span>
                            <input type="file" id="fileInput" accept="image/png, image/jpeg , image/jpg  , application/pdf" onChange={(e) => onInputChange(e, 'photo')} className="file-input" />
                        </div>

                        {userUpdateData?.photo && (
                            <div className="file-preview">
                                <div className="file-info">
                                    <a href={window.cn(userImage) ? URL.createObjectURL(userUpdateData?.photo) : userUpdateData?.photo?.url} target="_blank" rel="noopener noreferrer" className="file-name">
                                        {userUpdateData?.photo.name}
                                    </a>
                                    <span className="file-details">
                                        {userUpdateData?.photo.type} &nbsp;♦&nbsp; {(userUpdateData?.photo.size / 1024).toFixed(2)} KB
                                    </span>
                                </div>
                            </div>
                        )}

                        <small className="p-invalid-txt">{errors['photo']}</small>
                    </div>
                </div>
            </Dialog>

            {/* Close Add Update Photo Dialog */}
            <Dialog
                visible={confirmModal}
                style={{ width: '450px' }}
                header="Re-Generate Smart Card"
                modal
                footer={
                    <>
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            className="p-button-secondary"
                            onClick={closeRegenerateConfirm}
                        />
                        <Button
                            label="Confirm"
                            icon="pi pi-check"
                            className="p-button-success"
                            onClick={regenerateSmartCard}
                            loading={regenerateLoader}
                        />
                    </>
                }
                onHide={closeRegenerateConfirm}
            >
                <div className="flex align-items-center">
                    <i
                        className="pi pi-info-circle mr-3"
                        style={{ fontSize: '2rem', color: '#f59e0b' }}
                    />
                    <span>
                        Are you sure you want to re-generate the Smart Card?
                    </span>
                </div>
            </Dialog>

        </>
    );
};
